import { render, staticRenderFns } from "./AuthorCreate.vue?vue&type=template&id=94fa8412&scoped=true&"
import script from "./AuthorCreate.vue?vue&type=script&lang=js&"
export * from "./AuthorCreate.vue?vue&type=script&lang=js&"
import style0 from "./AuthorCreate.vue?vue&type=style&index=0&id=94fa8412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fa8412",
  null
  
)

export default component.exports